import { useEffect } from 'react'
import { useTransition, animated } from '@react-spring/web'
import { createPortal } from 'react-dom'
import X from '@mui/icons-material/Clear'
import Remove from '@mui/icons-material/Remove'

const DEFAULT_TRANSITION_CONFIG = {
  from: { y: '100%', opacity: 0 },
  enter: { y: '0%', opacity: 1 },
  leave: { y: '120%', opacity: 0 },
  config: { tension: 190, mass: 1.8 }
}

const LucaModal = ({
  open,
  onClose,
  children,
  maxWidth = 'max-w-6xl',
  maxHeight = 'max-h-[90vh]',
  footer = null,
  onMinimize = null,
  zIndex = 'z-[1300]'
}) => {
  const transition = useTransition(open, DEFAULT_TRANSITION_CONFIG)

  useEffect(() => {
    if (!open) return
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [open])

  const modalRoot =
    typeof document !== 'undefined' ? document.getElementById('modal-root') ?? document.body : null

  if (!modalRoot) return null

  return createPortal(
    transition(
      (style, show) =>
        show && (
          <div className={`fixed inset-0 ${zIndex} flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm`}>
            <animated.div
              style={{
                transform: style.y.to(y => `translateY(${y})`),
                opacity: style.opacity
              }}
              className={`relative flex flex-col w-full ${maxWidth} bg-[#f2f2f2] rounded-3xl overflow-hidden shadow-2xl ${maxHeight}`}
              onClick={e => e.stopPropagation()}
            >
              {/* Header - Estética ResizableModal */}
              <div className='bg-primary px-4 py-2 flex items-center justify-end'>
                <div className='flex items-center gap-1'>
                  {onMinimize && (
                    <button
                      type='button'
                      onClick={onMinimize}
                      className='text-white hover:bg-white/20 rounded p-0.5 transition-colors'
                    >
                      <Remove style={{ fontSize: 18 }} />
                    </button>
                  )}
                  <button
                    type='button'
                    onClick={onClose}
                    className='text-white hover:bg-white/20 rounded p-0.5 transition-colors'
                  >
                    <X style={{ fontSize: 18 }} />
                  </button>
                </div>
              </div>

              {/* Contenido con altura dinámica */}
              <div className='flex-1 overflow-hidden bg-white flex flex-col'>
                {children}
              </div>

              {/* Footer opcional */}
              {footer && (
                <div className='px-6 py-2 flex justify-end gap-3 bg-white border-t border-slate-100'>
                  {footer}
                </div>
              )}
            </animated.div>
          </div>
        )
    ),
    modalRoot
  )
}

export default LucaModal
